import BaseOptionsBundle from "%/dynamic-components/render-engine/classes/base-options";
import LayoutGap from "%/dynamic-components/render-engine/options/layout-options/layout-gap";
import HorizontalLayoutAlign from "%/dynamic-components/render-engine/options/layout-options/horizontal-layout-align";
import HorizontalLayoutVerticalAlign from "%/dynamic-components/render-engine/options/layout-options/horizontal-layout-vertical-align";
import LayoutDirection from "%/dynamic-components/render-engine/options/layout-options/layout-direction";
import Overflow from "%/dynamic-components/render-engine/options/layout-options/overflow";
import LayoutWidth from "%/dynamic-components/render-engine/options/layout-options/layout-width";
import LayoutHeight from "%/dynamic-components/render-engine/options/layout-options/layout-height";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";
import MaxWidth from "%/dynamic-components/render-engine/options/spacing-options/max-width";
import MaxHeight from "%/dynamic-components/render-engine/options/spacing-options/max-height";
import MinHeight from "%/dynamic-components/render-engine/options/spacing-options/min-height";
import MinWidth from "%/dynamic-components/render-engine/options/spacing-options/min-width";
import LayoutWrap from "%/dynamic-components/render-engine/options/layout-options/layout-wrap";
import ScaleWidthAnchor from "%/dynamic-components/render-engine/options/layout-options/scale-width-anchor";

export default class HorizontalLayoutPositionOptions extends BaseOptionsBundle {
  optionTitle = "Layout";
  inspectorToolGroup = "layout";
  useInspectorLabel = false;
  static optionClassName = "i-dynamic-horizontal-layout-position";
  static userInterfaceComponent = {
    component: inspectorTools.HORIZONTAL_POSITION_TOOL_SET,
  };

  constructor(values = {}) {
    super(values, [
      LayoutWidth,
      LayoutHeight,
      MaxWidth,
      MaxHeight,
      MinHeight,
      MinWidth,
      LayoutDirection,
      Overflow,
      HorizontalLayoutAlign,
      HorizontalLayoutVerticalAlign,
      LayoutGap,
      new LayoutWrap({
        default: "nowrap",
      }),
      ScaleWidthAnchor,
    ]);
  }
}
